export const CONFIG_LS_UPDATE = 'CONFIG_LS_UPDATE';
export const CONFIG_UPDATE = 'CONFIG_UPDATE';